import React, { useState } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const CustomPagination = ({ currentPage, totalPages, setCurrentPage }) => {
  const [pageRange, setPageRange] = useState({ start: 1, end: 5 });
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Calculate the range of pages to show
  const calculatePageRange = () => {
    const maxVisiblePages = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let end = Math.min(totalPages, start + maxVisiblePages - 1);

    // Ensure the range doesn't go beyond the total pages
    if (end - start < maxVisiblePages - 1) {
      start = Math.max(1, end - maxVisiblePages + 1);
    }

    setPageRange({ start, end });
  };

  // Update page range when the current page changes
  React.useEffect(() => {
    calculatePageRange();
  }, [currentPage, totalPages]);

  return (
    <Pagination className="pagination-rounded mb-sm-0">
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink onClick={() => handlePageChange(currentPage - 1)}>Previous</PaginationLink>
      </PaginationItem>

      {[...Array(totalPages)].map((_, index) => {
        const pageNumber = index + 1;
        // Only render page numbers within the current page range
        if (pageNumber >= pageRange.start && pageNumber <= pageRange.end) {
          return (
            <PaginationItem active={currentPage === pageNumber} key={pageNumber}>
              <PaginationLink onClick={() => handlePageChange(pageNumber)}>{pageNumber}</PaginationLink>
            </PaginationItem>
          );
        }
        return null; // Don't render the page if it's outside the range
      })}

      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink onClick={() => handlePageChange(currentPage + 1)}>Next</PaginationLink>
      </PaginationItem>
    </Pagination>
  );
};

export default CustomPagination;
